import axios from 'axios';

export default () => {
	return axios.create({
		baseURL: window.tradeConcernCommonApiUrl,
		withCredentials: false,
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		}
	})
}